module.exports = __webpack_public_path__ + "static/media/avatar.01a43cc4.png";